export default __webpack_public_path__ + "static/media/stars.8ca59104.svg";